<template>
  <div class="import-policyinfo-log">
    <el-tabs v-model="activeTabName" type="card">
      <el-tab-pane
        v-for="(item, index) in tabList"
        :key="index"
        :label="item.name"
        :name="item.key"
      ></el-tab-pane>
    </el-tabs>

    <QS-common-table
      :data="taskTableData"
      :columns="taskTableColumns"
      row-key="id"
      :pagination="pagination"
      :loading="loading"
      @change="paginationChange"
    >
    </QS-common-table>

    <el-dialog title="错误详情" :visible.sync="dialog.visible" @closed="handleDialogClose">
      <QS-common-table
        :loading="dialog.loading"
        :data="dialog.errorTableData"
        :columns="errorTableColumns"
        :pagination="dialog.pagination"
        @change="dialogPaginationChange"
      >
      </QS-common-table>
    </el-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import { uploadTaskGetPage, uploadTaskGetDetail } from '@/api/currencyApi'
import { downloadTaskErrorDetail } from '@/api/domain/vehicle'
import { downloadFileByUrl } from '@/utils/download'
import { taskTableColumns, errorTableColumns } from './config'

export default {
  props: {
    uploadType: {
      type: Number,
      default: 1,
    },
    tabName: {
      type: String,
      default: '',
    },
    downloadFileName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      activeTabName: 'baseLogPage',
      tabList: [
        {
          name: this.tabName,
          key: 'baseLogPage',
          number: 0,
          value: 1,
        },
      ],
      taskTableData: [],
      pagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [5, 10, 20, 50],
      },
      loading: false,
      dialog: {
        visible: false,
        errorTableData: [],
        taskId: null,
        loading: false,
        pagination: {
          pageSize: 10,
          pageNum: 1,
          total: 0,
          pageSizes: [10, 20, 30, 50, 100],
        },
      },
      errorTableColumns: errorTableColumns.call(this),
      taskTableColumns: taskTableColumns.call(this),
    }
  },
  methods: {
    paginationChange(payload) {
      const { pagination } = payload
      this.pagination.pageSize = pagination.pageSize
      this.pagination.pageNum = pagination.pageNum
      this.getUploadTaskData()
    },

    // 获取列表数据
    async getUploadTaskData() {
      this.loading = true
      const params = {
        uploadType: this.uploadType,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.pageNum,
      }
      uploadTaskGetPage(params).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.taskTableData = data?.items || []
          this.pagination.total = data?.totalNum || 0
        }
      }).finally(() => {
        this.loading = false
      })
    },

    // 错误详情弹窗显示并获取数据
    async getUploadTaskErrorDetail() {
      this.dialog.visible = true
      this.dialog.loading = true
      const params = {
        pageNum: this.dialog.pagination.pageNum,
        pageSize: this.dialog.pagination.pageSize,
        id: this.dialog.taskId,
      }
      uploadTaskGetDetail(params).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.dialog.errorTableData = data.items
          this.dialog.pagination.total = data.totalNum
        }
      }).finally(() => {
        this.dialog.loading = false
      })
    },

    // 点击错误说明-错误详情
    // eslint-disable-next-line vue/no-unused-properties
    viewErrorDetail(id) {
      this.dialog.taskId = id
      this.getUploadTaskErrorDetail()
    },

    // 下载错误明细
    // eslint-disable-next-line vue/no-unused-properties
    downloadErrorDetail(id) {
      downloadTaskErrorDetail({ id })
        .then((res) => {
          const { code, data } = res
          if (code === 1 && data) {
            const dateTime = moment().format('YYMMDDHHmmss')
            const fileName = `${this.downloadFileName}-${dateTime}.xlsx`
            this.downloadFileByUrl(data, fileName)
          }
        })
    },
    downloadFileByUrl(url, fileName) {
      downloadFileByUrl(url, fileName)
    },
    handleDialogClose() {
      this.dialog.errorTableData = []
      this.dialog.total = 0
      this.dialog.pageSize = 10
      this.dialog.pageNum = 1
      this.dialog.taskId = null
    },
    dialogPaginationChange(payload) {
      const { pagination } = payload
      this.dialog.pagination.pageSize = pagination.pageSize
      this.dialog.pagination.pageNum = pagination.pageNum
      this.getUploadTaskErrorDetail()
    },
  },
  created() {
    this.getUploadTaskData()
  },
}
</script>

<style lang="scss" scoped>
  .table-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .table-pagination {
    margin-top: 12px;
  }
</style>
